import { App } from 'vue'
import VueSlider from 'vue-slider-component'

export default {
  install(app: App<Element>): any {
    app.component('vue-range-slider', VueSlider)
  }
}
